// Centralised sarcasm. Dry. British-ish. Not abusive — just disappointed.

export const empty = {
  inbox: [
    "Inbox empty. Either you're enlightened or you haven't started yet.",
    "Nothing in the inbox. Suspicious.",
    "Inbox zero. Or just denial. Hard to tell.",
  ],
  today: [
    "Nothing today. A bold strategy.",
    "Today's list is empty. The day, presumably, is not.",
    "No focus tasks. The void appreciates your contribution.",
  ],
  next: [
    "No next actions. Heroic.",
    "Empty. Either you've finished life, or you've avoided planning it.",
  ],
  waiting: [
    "Nobody owes you anything. Refreshing.",
    "No one is keeping you waiting. For once.",
  ],
  scheduled: [
    "Nothing scheduled. Time, an illusion.",
  ],
  someday: [
    "No someday/maybe items. So, just maybe?",
    "Empty. Your future self thanks you, possibly.",
  ],
  logbook: [
    "Nothing finished yet. There's a first time for everything.",
  ],
  projects: [
    "No projects. Just vibes, then.",
  ],
  search: [
    "Nothing matches. Spelling is a skill.",
  ],
};

export const toasts = {
  taskCreated: "Added. Don't just stare at it.",
  taskCompleted: "Done. Look at you.",
  taskDeleted: "Gone. Like it never existed. Because it doesn't.",
  taskUpdated: "Updated. Riveting.",
  projectCreated: "Project added. Now do it.",
  signedIn: "Welcome back. The list missed you.",
  signedUp: "Account created. The list is now your problem.",
  signedOut: "Signed out. The tasks will wait. They always do.",
};

export const errors = {
  generic: "Something failed. Try again. Or don't.",
  network: "The internet, briefly, doesn't believe in you.",
  notFound: "Gone. Or never was. Hard to say.",
  unauthorized: "You'll need to sign in for that — sorry, them's the rules.",
  passkeyFailed: "Passkey didn't take. Your finger or the universe — pick one.",
  signupTaken: "That email is already procrastinating elsewhere.",
};

export const labels = {
  inboxTagline: "Where ideas come to wait their turn.",
  todayTagline: "The shortlist. Pick your battles.",
  nextTagline: "The honest list. Sorted by context.",
  waitingTagline: "Other people's problems. For now.",
  scheduledTagline: "Future you, take it away.",
  somedayTagline: "Dreams, mildly organised.",
  logbookTagline: "Receipts.",
};

export function pick(arr: readonly string[], seed = Date.now()): string {
  return arr[seed % arr.length] ?? "";
}
